// Stylesheets
import 'styles/home.scss';

// Third party libraries
import React from 'react';

// MUI imports
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ICON_URL } from 'constants.js';

const Home = () => {
  return (
    <>
      <div className="splashBackground"/>
      <Container className="splash">
        <Stack spacing={4} direction="row">
          <Box>
            <img alt="Logo" src={ICON_URL} />
          </Box>
          <Box className="splashText">
            <Typography className="lineOne" variant="span">
              Welcome to the
            </Typography>
            <Typography className="lineTwo" fontWeight="bold" variant="span">
              Collaborative
            </Typography>
            <Typography className="lineThree" sx={{ fontSize: '3.2rem' }} fontWeight="bold" variant="span">
              Planning Portal!
            </Typography>
            <div className="divider"></div>
            <Typography>
              The Collaborative Planning Portal provides tools and information to assist with community wildfire protection planning.
            </Typography>
          </Box>
        </Stack>
      </Container>
    </>
  );
}

export default Home;